module.exports = __webpack_public_path__ + "img/persondoc.9e123a73.svg";